export const getInitialState = isMockedData => {
  if (isMockedData) {
    return {
      selectedMassId: null,
      masses: [
        {
          id: '1',
          massDate: '2020-12-01T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '2',
          massDate: '2020-12-02T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '3',
          massDate: '2020-12-03T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '4',
          massDate: '2020-12-04T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '5',
          massDate: '2020-12-05T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '6',
          massDate: '2020-12-06T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '7',
          massDate: '2020-12-07T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
        {
          id: '8',
          massDate: '2020-12-08T17:00:00+0000',
          availableMassOfferings: 1,
          hasHour: true,
          unavailableBecauseOfMinimumFromDate: false,
          unavailableBecauseOfEvenDistribution: false,
        },
      ],
    };
  }

  return {
    selectedMassId: null,
    masses: [],
  };
};
